import { useState } from 'react'
import { Outlet, useParams } from 'react-router-dom'

import { PlanningPeriodDetailDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import SubmissionPeriodFormModal from 'modules/planning/components/SubmissionPeriodFormModal'
import ManageCollaboratorsModal from 'modules/planning/components/ManageCollaborators'
import { PeriodWizard } from 'modules/planning/components/PeriodWizard'

const PeriodDetailPage = () => {
  const { periodId } = useParams<{ periodId: string }>()
  const { company } = useCurrentSession()
  const [isSubmissionModalOpen, setIsSubmissionModalOpen] = useState(false)
  const [isCollaboratorsModalOpen, setIsCollaboratorsModalOpen] = useState(false)
  const [isEditWizardOpen, setIsEditWizardOpen] = useState(false)

  const { data, loading, error } = useQuery(PlanningPeriodDetailDocument, {
    variables: { id: periodId ?? '' },
    skip: !periodId,
  })

  const period = data?.planning?.period
  // Each planning period supports at most one active submission period; take the first one.
  const submissionPeriod = period?.submissionPeriods?.[0]

  const handleActionClick = (key: string) => {
    if (key === 'edit-period') {
      setIsEditWizardOpen(true)
    }

    if (key === 'manage-collaborators') {
      setIsCollaboratorsModalOpen(true)
    }

    if (key === 'submission-period') {
      setIsSubmissionModalOpen(true)
    }
  }

  return (
    <ResponsivePage.Body
      variant="full"
      onActionClick={handleActionClick}
      loading={loading}
      error={error}
      authorized={!!period}
    >
      <Outlet context={{ period, periodId }} />

      {isSubmissionModalOpen && periodId && (
        <SubmissionPeriodFormModal
          periodId={periodId}
          companyId={company.id}
          submissionPeriod={
            submissionPeriod
              ? {
                  id: submissionPeriod.id,
                  startDate: submissionPeriod.startDate,
                  endDate: submissionPeriod.endDate,
                }
              : undefined
          }
          onClose={() => setIsSubmissionModalOpen(false)}
        />
      )}

      {isCollaboratorsModalOpen && periodId && (
        <ManageCollaboratorsModal
          periodId={periodId}
          onClose={() => setIsCollaboratorsModalOpen(false)}
        />
      )}

      {isEditWizardOpen && period && (
        <PeriodWizard
          period={period}
          onClose={() => setIsEditWizardOpen(false)}
          onSuccess={() => setIsEditWizardOpen(false)}
        />
      )}
    </ResponsivePage.Body>
  )
}

export default PeriodDetailPage
